import { toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex flex-col h-full space-y-8" }
const _hoisted_3 = { class: "flex flex-col space-y-4.5" }
const _hoisted_4 = { class: "error-msg" }
const _hoisted_5 = { class: "flex flex-col space-y-1" }
const _hoisted_6 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_7 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_8 = { class: "flex flex-col flex-grow mb-8 space-y-2" }
const _hoisted_9 = { class: "text-muted" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-base material-icons-outlined" }, "done", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TextInput, {
          modelValue: _ctx.course.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.course.name) = $event))
        }, _createSlots({
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("course_creation_form.course_name")) + " ", 1)
          ]),
          _: 2
        }, [
          (_ctx.v$.course.name.$errors.length > 0)
            ? {
                name: "errors",
                fn: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.course.name.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: error.$uid
                    }, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("validation_errors." + error.$uid)), 1)
                    ]))
                  }), 128))
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["modelValue"]),
        _createVNode(_component_TextEditor, {
          modelValue: _ctx.course.description,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.course.description) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("course_creation_form.course_description")), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t("course_creation_form.course_visibility")), 1),
        _createVNode(_component_Toggle, {
          modelValue: _ctx.course.hidden,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.course.hidden) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("course_creation_form.hide_course")), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (_ctx.course.hidden)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t("course_creation_form.hidden_description")), 1))
          : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t("course_creation_form.public_description")), 1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t("course_creation_form.import_exercises")), 1),
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("course_creation_form.import_exercises_description")), 1),
        false
          ? (_openBlock(), _createBlock(_component_FileUpload, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          type: "file",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.onFileUploadClick()), ["prevent"]))
        })
      ]),
      _createVNode(_component_Btn, {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.$invalid ? _ctx.v$.$touch() : _ctx.onCreate())),
        class: "mt-auto mr-auto",
        variant: 'success',
        loading: _ctx.localLoading
      }, {
        default: _withCtx(() => [
          _hoisted_10,
          _createTextVNode(_toDisplayString(_ctx.$t("course_creation_form.create")), 1)
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ]))
}